(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('siteUpdateProductAction', {
      controller: Controller,
      templateUrl: 'actions/site/updateProduct/updateProduct-site.action.html',
      bindings: {
        siteId: '<',
        registration: '<',
        productId: '<',
        supplierId: '<',
        gallery: '<',
        then: '&',
        catch: '&'
      }
    });
}());
